import { Component } from 'react'
import { connect } from 'react-redux'

const HOC = ( WrappedComponent ) => {
  class WithHOC  extends Component {
    state = {}

    render = () => {
      return (
        <WrappedComponent { ...this.props } />
      )
    }
  }

  const mapStateToProps = state => ({
    data: state,
    profile: state.ProfileReducer.profile
  })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC
